import { type ClassValue, clsx } from "clsx"
import { extendTailwindMerge } from "tailwind-merge"
import { playTokens } from "@/lib/theme/playTokens"

const { theme, radius } = playTokens
const steps = (scale: object, prefix = "") => Object.keys(scale).map((step) => `${prefix}${step}`)

// Teach tailwind-merge the theme utilities from design/tokens/tailwind.preset.js, so cn() resolves conflicts
// between them and the default scales (otherwise `text-size-s` reads as a text colour and is dropped).
const twMerge = extendTailwindMerge({
  extend: {
    theme: {
      text: steps(theme.text, "size-"),
      spacing: steps(theme.space).filter((step) => step !== "zero"),
      radius: [...steps(theme.radius, "theme-"), ...steps(radius, "play-")],
      shadow: steps(theme.shadow, "theme-"),
      ease: ["theme", "theme-large"],
    },
    classGroups: {
      duration: [{ duration: ["theme", "theme-large"] }],
    },
  },
})

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}
